﻿import React, { useEffect, useState, useRef, Fragment } from 'react';
import moment from 'moment';
import readXlsxFile from 'read-excel-file'
import { createFocusTrap } from 'focus-trap';

import LockOverflowScroll from '../../../../Resources/Scripts/_Shared/hooks/useLockBodyScroll'

//import { useProductAvailability } from '../../BookingFlowPage/Scripts/hooks/useProductAvailability'

import { permitService } from './Endpoints'
import { products } from '../../BookingFlowPage/Scripts/Endpoints'
import { Lightbox } from '../../BookingFlowPage/Scripts/partials/Lightbox'

import { closeOverlay, openOverlay } from '../../_Shared/Scripts/LandLordPermitOverlay'
import { emailValidation, phoneNumberValidation } from '../../BookingFlowPage/Scripts/Validation'
import { usePrevious } from '../../BookingFlowPage/Scripts/hooks/usePrevious'
import { paramsToObject } from '../../../../Resources/Scripts/_Shared/history'
import { parseDate } from '../../../../Resources/Scripts/_Shared/parseDate'

import { Divider } from '../../../../Resources/Scripts/_Shared/elements/Divider'
import { TwoColumnWrapper, ThreeColumnWrapper } from '../../../../Resources/Scripts/_Shared/elements/ColumnWrapper'

import { OneLineWrapper } from '../../../../Resources/Scripts/_Shared/elements/OneLineWrapper'
import { DropdownlistWithLabel } from '../../../../Resources/Scripts/_Shared/elements/DropdownlistWithLabel'
import { InputWithLabel } from '../../../../Resources/Scripts/_Shared/elements/InputWithLabel'
import { TextareaWithLabel } from '../../../../Resources/Scripts/_Shared/elements/TextareaWithLabel'
import { DateSelectionWithLabel } from '../../../../Resources/Scripts/_Shared/elements/DateSelectionWithLabel'
import { ColumnList } from '../../../../Resources/Scripts/_Shared/elements/ColumnList'

import { validateFormObject } from '../../BookingFlowPage/Scripts/Validation'
import { Dialog } from '../../../../Resources/Scripts/_Shared/elements/Dialog'
import { Error } from '../../../../Resources/Scripts/_Shared/elements/Error'

const emptyGuid = '00000000-0000-0000-0000-000000000000';

const PermitForm = ({ lang, context, permitId, customerNumber }) => {
	const selectedLang = document.querySelector('html').getAttribute('lang');
	const currentCountry = document.querySelector('html').getAttribute('country');
	const selectedLocale = currentCountry === 'no' ? 'nb' : currentCountry === 'se' ? 'sv' : currentCountry;
	const defaultCountryCode = currentCountry === 'no' ? 'N' : currentCountry === 'se' ? 'S' : 'FIN';
	const defaultCountryCodes = [{ Id: 'S', Name: 'S' }, { Id: 'FIN', Name: 'FIN' }, { Id: 'N', Name: 'N' }, { Id: 'DK', Name: 'DK' }];
	const countryCodeOptions = [
		...defaultCountryCodes.filter(cc => cc.Id === defaultCountryCode),
		...defaultCountryCodes.filter(cc => cc.Id !== defaultCountryCode),
	];
	for (const [value] of Object.entries(lang.permit.licensePlateCountryCodes)) {
		if (value !== 'FIN' && value !== 'N' && value !== 'S' && value !== 'N' && value !== 'DK') countryCodeOptions.push({ Id: value, Name: value });
	};

	LockOverflowScroll();
	//moment().locale(selectedLocale);
	const importOverlayBackgroundRef = useRef(null);

	const [postFormPending, setPostFormPending] = useState(false);

	const [showSaveButtonCheck, setShowSaveButtonCheck] = useState(false);
	const [savedPermits, setSavedPermits] = useState(null);
	const [showRegisteredCustomerForm, setShowRegisteredCustomerForm] = useState(false);
	const [showUnregistredCustomerForm, setShowUnregistredCustomerForm] = useState(false);
	const [showImportCustomerOverlay, setShowImportCustomerOverlay] = useState(false);

	const defaultTextboxSettings = { text: '', required: true };
  const defaultTextboxSettingsNotRequired = { text: '' };
	const defaultDateSettings = { date: null, required: true, elementType: 'date' };

	const userTypeOptions = [{ Text: 'Registered user', Id: 'registered' }, { Text: 'Unregistered user', Id: 'unregistered' }];
	const [userType, setUserType] = useState({ item: userTypeOptions[0], required: true, elementType: 'select' });
	const [currentUserSelection, setCurrentUserSelection] = useState(emptyGuid);
	const [userSelection, setUserSelection] = useState({ item: { Name: lang.permit.selectperson, Uid: emptyGuid }, required: true, elementType: 'select' });

	const [firstName, setFirstName] = useState(defaultTextboxSettings);
	const [lastName, setLastName] = useState(defaultTextboxSettings);
	const [email, setEmail] = useState({ ...defaultTextboxSettingsNotRequired, elementType: 'email' });
	const [phone, setPhone] = useState({ ...defaultTextboxSettingsNotRequired, elementType: 'phone' });
	const [registrationPlate, setRegistrationPlate] = useState({ ...defaultTextboxSettings, elementType: 'licenseplate' });
	const [countryCode, setCountryCode] = useState({ item: { Name: defaultCountryCode, Id: defaultCountryCode }, required: false, elementType: "select" });
  const [quantity, setQuantity] = useState(defaultTextboxSettings);

	const [placeSelection, setPlaceSelection] = useState({ item: { Name: lang.permit.chooseplace, Id: emptyGuid }, required: true, elementType: 'select' });
  const [placeSelectionOptions, setPlaceSelectionOptions] = useState([]);
	const [placeSelectionPending, setPlaceSelectionPending] = useState(true);
	const [typeSelection, setTypeSelection] = useState({ item: { Name: lang.permit.choosetype, PmcId: emptyGuid }, required: true, elementType: 'select' });
  const [originalTypeSelection, setOriginalTypeSelection] = useState(null);
  const [typeSelectionOptions, setTypeSelectionOptions] = useState([]);
  const prevPlaceSelection = usePrevious(placeSelection);

	const [startDate, setStartDate] = useState(defaultDateSettings);
	const [startTime, setStartTime] = useState({ ...defaultTextboxSettings, elementType: 'time' });
	const [endDate, setEndDate] = useState({ ...defaultDateSettings, required: false });
	const [endTime, setEndTime] = useState({ ...defaultTextboxSettingsNotRequired, elementType: 'time' });
	const [dateValidationError, setDateValidationError] = useState(false);
	const [spaceNumber, setSpaceNumber] = useState(defaultTextboxSettings);
	const [notes, setNotes] = useState(defaultTextboxSettingsNotRequired);
	const [internalNotes, setInternalNotes] = useState(defaultTextboxSettingsNotRequired);

  const [disabledStartDate, setDisabledStartDate] = useState(false)
  const [disabledEndDate, setDisabledEndDate] = useState(false)

	const [people, setPeople] = useState([]);
	const [peopleList, setPeopleList] = useState([]);
  const [quantityCount, setQuantityCount] = useState(0);

	const [permitDetails, setPermitDetails] = useState(null);
	const [permitDetailsPending, setPermitDetailsPending] = useState(permitId ? true : false);
	const [permitDetailsError, setPermitDetailsError] = useState(false);
	const [permitCreateError, setPermitCreateError] = useState(false);
	const [permitUpdateError, setPermitUpdateError] = useState(false);
	const [permitUpdateErrorMessage, setPermitUpdateErrorMessage] = useState('');

  const [availableSpotsPending, setAvailableSpotsPending] = useState(false);
  const [availableSpots, setAvailableSpots] = useState(null);

	const formData = permitId ? { userTypeOptions, userType, setUserType, currentUserSelection, userSelection, setUserSelection, firstName, setFirstName, lastName, setLastName, email, setEmail, phone, setPhone, registrationPlate, setRegistrationPlate, countryCode, setCountryCode, quantity, setQuantity } : {}
	const [showPermitDetails, setShowPermitDetails] = useState(false);

	const cancelClickHandler = () => {
		closeOverlay(context);
	}

	const saveClickHandler = async () => {
		setPostFormPending(true);
		let permitData = {}

		let newUserForm = {
			placeSelection: { value: placeSelection, setValue: setPlaceSelection, optionIdentifier: 'Id' },
			typeSelection: { value: typeSelection, setValue: setTypeSelection, optionIdentifier: 'PmcId' },
			startDate: { value: startDate, setValue: setStartDate },
			startTime: { value: startTime, setValue: setStartTime },
			endDate: { value: endDate ? endDate : null, setValue: setEndDate },
			endTime: { value: endTime ? endTime : null, setValue: setEndTime },
		};

		if ((permitId && userType.item.Id === 'registered') || customerNumber) {
			newUserForm.quantity = { value: quantity, setValue: setQuantity };
			if (typeSelection.item.ReservationType == 'LANDLORD_RESERVED') newUserForm.spaceNumber = { value: spaceNumber, setValue: setSpaceNumber };
		} else if (permitId) {
      newUserForm = {
        ...newUserForm,
        firstName: { value: firstName, setValue: setFirstName },
        lastName: { value: lastName, setValue: setLastName },
        email: { value: email, setValue: setEmail },
        phone: { value: phone, setValue: setPhone },
				registrationPlate: { value: { ...registrationPlate, countryCode: countryCode.item.Id }, setValue: setRegistrationPlate },
				countryCode: { value: countryCode, setValue: setCountryCode, optionIdentifier: 'Id' },
			}
			if (typeSelection.item.ReservationType == 'LANDLORD_RESERVED') newUserForm.spaceNumber = { value: spaceNumber, setValue: setSpaceNumber };
		}

		let [formValidationError, _, flatCleanFormData] = validateFormObject(newUserForm, lang.errorMessages);
		const missingRegisteredCustomer = !!(permitId && userType.item.Id === 'registered' && userSelection.item?.uid === emptyGuid); 

		if (missingRegisteredCustomer || formValidationError) {
			setPostFormPending(false);
			if (missingRegisteredCustomer)
				setUserSelection({ ...userSelection, error: lang.errorMessages.required });
			setTimeout(() => {
				const firstInvalidElement = missingRegisteredCustomer ? document.querySelector('[aria-invalid]').parentElement.previousElementSibling : document.querySelector('[aria-invalid]').closest('label');
				if (firstInvalidElement) firstInvalidElement.scrollIntoView({ behavior: 'smooth' });
			}, 500);
			return;
		}

		if (!permitId && !customerNumber && people.length === 0) {
			setPostFormPending(false);
			return;
		}
		const cleanStartDate = parseDate(flatCleanFormData.startDate, 'sv', 'L');
    const startDateTimeIso = `${cleanStartDate} ${flatCleanFormData.startTime}`;
		const cleanEndDate = flatCleanFormData.endDate ? parseDate(flatCleanFormData.endDate, 'sv', 'L') : null;
		const endDateTimeIso = cleanEndDate ? `${cleanEndDate} ${flatCleanFormData.endTime}` : null;

    const permitInformation = {
      pmcIdRef: flatCleanFormData.typeSelection,
      validity: {
        validFrom: startDateTimeIso,
				validTo: endDateTimeIso ? endDateTimeIso : null
				//To not send the validTo property at all:
				//...(endDateTimeIso && { validTo: endDateTimeIso })
      }
    }
		let createPermitsResponse;
		let updatePermitResponse;

		//Update existing permit
		if (permitId) {
			let customerInfo = {};
			if (userType.item.Id === 'registered' && userSelection.item?.Uid === currentUserSelection) {
        customerInfo = {
          customer: {
            uid: userSelection.item?.Uid,
					},
					freetextParkingSpaceNo: spaceNumber.text,
					notes: notes.text,
					internalNote: internalNotes.text,
          registrationPlates: permitDetails.registrationPlates,
          quantity: flatCleanFormData.quantity,
				};
      } else if (userType.item.Id === 'registered' && userSelection.item?.Uid !== currentUserSelection) {
        customerInfo = {
          customer: {
            uid: userSelection.item?.Uid,
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: ''
					},
					freetextParkingSpaceNo: spaceNumber.text,
					notes: notes.text,
					internalNote: internalNotes.text,
          registrationPlates: null,
          quantity: flatCleanFormData.quantity,
        };
			} else {
        customerInfo = {
          customer: {
            firstName: flatCleanFormData.firstName,
            lastName: flatCleanFormData.lastName,
            email: flatCleanFormData.email,
            phoneNumber: flatCleanFormData.phone,
					},
					freetextParkingSpaceNo: spaceNumber.text,
					notes: notes.text,
					internalNote: internalNotes.text,
					registrationPlates: [{ plateText: flatCleanFormData.registrationPlate, countryCode: flatCleanFormData.countryCode }],
          quantity: '1',
        }
      }

      const permitData = {
		  permitId,
		  data: {
			  ...permitInformation,
			  ...customerInfo,
          },        
			}

			updatePermitResponse = await permitService.updatePermit(permitData, false, selectedLang);
			//console.log('[UPDATE PERMIT]', updatePermitResponse, permitData);

			if (updatePermitResponse.status === 200) {
				setTimeout(() => {
					setPostFormPending(false);
					setTimeout(() => setShowSaveButtonCheck(true), 10);
				}, 500);
				setTimeout(() => {
					setDisabledEndDate(true)
					setDisabledStartDate(true)
					const urlParams = new URLSearchParams(window.location.search);
					urlParams.delete('permitId');

					let newUrl = window.location.origin + window.location.pathname;
					if (urlParams.toString().length > 0)
						newUrl += '?' + urlParams.toString()

					history.replaceState(paramsToObject(urlParams), document.title, newUrl);
					location.reload();
				}, 1500);

				return;
			} else {
				setDisabledEndDate(true)
				setDisabledStartDate(true)
				setPostFormPending(false);
				setPermitUpdateErrorMessage(updatePermitResponse.errorMessage)
				setPermitUpdateError(true);
			}
		}

		//Create new permits
    else {
      if (!customerNumber) {
        const permits = people.map((person, rowId) => ({
          ...permitInformation,
          customer: {
            uid: person.id === 'new' ? null : person.id,
            firstName: person.firstName,
            lastName: person.lastName,
						email: person.email ? person.email.replace(/-\s*$/, '') : '',
						phoneNumber: person.phone ? `${person.phone}`.replace(/-\s*$/, '') : ''
					},
					freetextParkingSpaceNo: person.spaceNumber,
					notes: person.notes,
					internalNote: person.internalNotes,
					registrationPlates: person.id === 'new' ? [{ plateText: person.registrationPlate, countryCode: person.countryCode }] : null,
          quantity: person.id === 'new' ? 1 : person.quantity ?? 1,
          rowId,
        }))

        permitData = {
          insert: {
            permits: permits
          }
        }
      }
      else {
        permitData = {
          insert: {
            permits: [{
              ...permitInformation,
              customer: {
                uid: customerNumber,
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
							},
							freetextParkingSpaceNo: flatCleanFormData.spaceNumber,
							notes: notes.text,
							internalNote: internalNotes.text,
              registrationPlates: null,
              quantity: flatCleanFormData.quantity,
              rowId: 0,
            }]
          }
        }
      }

			createPermitsResponse = await permitService.createPermits(permitData, false, selectedLang);
			//console.log('[CREATE PERMIT]', createPermitsResponse, permitData);

			if (createPermitsResponse.status === 200 && createPermitsResponse.body.success !== 0) {
				setTimeout(() => {
					setPostFormPending(false);
					setTimeout(() => setShowSaveButtonCheck(true), 10);
				}, 1000);
				const amountOfPermits = permitData.insert.permits.map(permit => { return +permit.quantity });
				setTimeout(() => {
					setSavedPermits(amountOfPermits.reduce((a, b) => a + b));
					setDisabledEndDate(true)
					setDisabledStartDate(true)
				}, 2000);

				return;
			} else {
				setDisabledEndDate(true)
				setDisabledStartDate(true)
				setPostFormPending(false);
				if (createPermitsResponse.errorMessage) {
					setPermitUpdateError(true)
					setPermitUpdateErrorMessage(createPermitsResponse.errorMessage)
				} else {
				const permits = permitData.permits;
				let newPeopleList = peopleList.slice(1)
				newPeopleList = newPeopleList.map((people, i) => {
					const hasError = createPermitsResponse.body.errors ? createPermitsResponse.body.errors.some(error => error.rowId === i) : null;
					return {
						...people,
						five: permits && permits.length ? permits[i].quantity : null,
						remove: null,
						error: hasError ? { heading: 'Error: ', message: createPermitsResponse.body.errors[i].errorMessage } : { heading: '', message: 'Permit created.' }
					}
				});

				setPeopleList([
					{ one: lang.permit.name, two: lang.permit.email, three: lang.permit.licenseplate, four: lang.permit.phone, five: 'Qty', heading: true, break: true },
					...newPeopleList
				]);
				setPermitCreateError(true);
				}
			}
		}


		

    //Show error
	}
	const handleDialogConfirm = () => {
		location.reload();
	}

	const showRegisteredCustomerFormClickHandler = () => {
		if (showRegisteredCustomerForm) {
			setShowRegisteredCustomerForm(false);
			setShowUnregistredCustomerForm(false);
		}
		else {
			setShowRegisteredCustomerForm(true);
			setShowUnregistredCustomerForm(false);
		}
	}

	const showUnregistredCustomerFormClickHandler = () => {
		if (showUnregistredCustomerForm) {
			setShowUnregistredCustomerForm(false);
			setShowRegisteredCustomerForm(false);
		}
		else {
			setShowUnregistredCustomerForm(true);
			setShowRegisteredCustomerForm(false);
		}
	}

	const addUserCallbackClickHandler = (newUser) => {
		const list = [...people, newUser]
    setPeople(list);
		setShowUnregistredCustomerForm(false);
		setShowRegisteredCustomerForm(false);
	}

	const removeUserCallbackClickHandler = (index) => {
		const currentPeopleList = people.filter((_, i) => i !== index);

    // if (currentPeopleList.length > 0) {
    //   const quantityCount = currentPeopleList.map(item => parseInt(item.quantity ?? 1)).reduce((accumulator, currentValue) => accumulator + currentValue)
    //   setQuantityCount(quantityCount);
    // }
    // else {
    //   setQuantityCount(0);
    // }

		setPeople(currentPeopleList);
	}

	const showImportCustomerOverlayClickHandler = (e) => {
		if (!e || e.target === importOverlayBackgroundRef.current) {
      setShowImportCustomerOverlay(!showImportCustomerOverlay);
			setShowUnregistredCustomerForm(false);
			setShowRegisteredCustomerForm(false);
    }
	}

	useEffect(() => {
		if (!permitId || !permitDetails)
			return;
		if (userType.item.Id === 'unregistered') {
			//setRegistrationPlate(defaultTextboxSettings);
			setRegistrationPlate({ ...defaultTextboxSettings, text: permitDetails.RegistrationPlates?.map(registrationPlate => registrationPlate.PlateText).join(', '), elementType:'licenseplate' });
		}
		else if (permitDetails.registrationPlates?.length)
			setRegistrationPlate({ text: permitDetails.RegistrationPlates?.map(registrationPlate => registrationPlate.PlateText).join(', ') });
		else
			setRegistrationPlate({ text: null });
  }, [userType, permitDetails])

	useEffect(() => {
		//Get sales locations

    let isSubscribed = true;

    const getPlaces = async () => {
      // setPlaceSelectionPending(true);

			const allPlaces = await permitService.getPlaces(false);

		  if (allPlaces.status === 200 && isSubscribed) {
				if (typeSelection.item.PmcId === emptyGuid && allPlaces.body.length > 0 && permitDetails && permitDetails.salesLocation) {
					const placeItem = allPlaces.body.filter(place => place.Id === permitDetails.salesLocation);

					if (placeItem.length > 0 && !permitDetailsPending)
						setPlaceSelection({ ...placeSelection, item: placeItem[0] });
				}

        setPlaceSelectionPending(false);
        setPlaceSelectionOptions(allPlaces.body);
      } else if (isSubscribed) {
        setPlaceSelectionPending(false);
        setPlaceSelection({ ...placeSelection, item: { ...placeSelection.item, Text: 'No places to show' }, noitems: true });
      }
    }
		getPlaces();
		

    return () => isSubscribed = false;
  }, [])

	const sortWeekdays = (schedule) => {
		if (!Array.isArray(schedule)) return [];
		const order = {
			"monday": 1,
			"tuesday": 2,
			"wednesday": 3,
			"thursday": 4,
			"friday": 5,
			"saturday": 6,
			"sunday": 7
		}

		return schedule.sort(function (a, b) {
			const day1 = a?.dayOfWeek?.toLowerCase?.();
			const day2 = b?.dayOfWeek?.toLowerCase?.();

			const val1 = order[day1] ?? 999;
			const val2 = order[day2] ?? 999;
			
			return val1 - val2;
		});
	}

	useEffect(() => {
    if (prevPlaceSelection && prevPlaceSelection.item.Id === placeSelection.item.Id) {
      return
    }

		const allTypes = placeSelection.item.ProductMarketCombinations?.map(item => ({
			Id: item.Id,
			Name: item.Name,
			PmcId: item.PmcId,
			MaxSalesAmount: item.MaxSalesAmount,
			PermitDetailsSchedule: sortWeekdays(item.ServiceProfile?.Schedule),
			ReservationType: item.ReservationType,
			StartSellingDate: parseDate(item.StartSellingDate, selectedLocale, 'L')
		})) ?? [];

		if (allTypes.length > 0) {
			setTypeSelectionOptions(allTypes.map(type => ({ ...type, PmcId: type.PmcId })));
			if (typeSelection.item.PmcId === emptyGuid && allTypes.length > 0 && permitDetails && permitDetails.pmcIdRef && !permitDetailsPending) {
				//console.log(permitDetails)
        const typeItem = allTypes.filter(type => type.PmcId === permitDetails.pmcIdRef);
				if (typeItem.length > 0 && !permitDetailsPending)
          setTypeSelection({ ...typeSelection, item: typeItem[0] })
      }
      else if (!permitDetailsPending) {
        setTypeSelection({ item: { Name: lang.permit.choosetype, PmcId: emptyGuid }, required: true, elementType: 'select' })
      }
    } else if (!permitDetailsPending) {
      setTypeSelection({ item: { Name: lang.permit.choosetype, PmcId: emptyGuid }, required: true, elementType: 'select' })
    }
  }, [placeSelection])

	useEffect(() => {
		//Get permit details (if permit id exist)
		let isSubscribed = true;

		if (!permitId)
			return;

		const getPermitDetails = async () => {
			setPermitDetailsPending(true);

			const permitDetails = await permitService.getPermitDetails({ permitId }, false, selectedLang);

			//console.log(permitDetails)

			if (permitDetails.status === 200 && isSubscribed) {
				if (permitDetails.body) {
					//Temp fix for old registration plate structure
					if (!permitDetails.body.registrationPlates && permitDetails.body.licensePlates) permitDetails.body.registrationPlates = permitDetails.body.licensePlates.map(plate => { return { plateText: plate, countryCode: defaultCountryCode } });
					setPermitDetails(permitDetails.body);
				}
				else
					setPermitDetailsPending(false), setPermitDetailsError(true);
			} else {
				setPermitDetailsPending(false);
				setPermitDetailsError(permitDetails.errorMessage);
			}
		}
		getPermitDetails();

    return () => isSubscribed = false;
	}, [])

	useEffect(() => {
		//Parse permit details into form data
		if (!permitDetails || !placeSelectionOptions.length === 0 || placeSelectionPending) {
			return;
		}
		if (permitDetails.Customer?.Uid) {
			setUserType({ ...userType, item: userTypeOptions[0] });
			setCurrentUserSelection(permitDetails.Customer?.Uid);
		} else {
			setUserType({ ...userType, item: userTypeOptions[1] });
			setFirstName({ ...firstName, text: permitDetails.Customer.FirstName });
			setLastName({ ...lastName, text: permitDetails.Customer.LastName });
			setEmail({ ...email, text: permitDetails.Customer.Email ?? '' });
			setPhone({ ...phone, text: permitDetails.Customer.PhoneNumber ?? '' });
		}
		const permitCountryCode = permitDetails.RegistrationPlates && permitDetails.RegistrationPlates.length && permitDetails.RegistrationPlates[0].CountryCode ? permitDetails.RegistrationPlates[0].CountryCode : defaultCountryCode;
		setRegistrationPlate({ ...registrationPlate, text: permitDetails.RegistrationPlates?.map(registrationPlate => registrationPlate.PlateText).join(', ') });
		setCountryCode({ ...countryCode, item: { Name: permitCountryCode, Id: permitCountryCode } });
		setQuantity({ ...quantity, text: permitDetails.Quantity });
		setStartDate({ ...startDate, date: parseDate(permitDetails.Validity.ValidFrom, selectedLocale, 'L') });
		setStartTime({ ...startTime, text: permitDetails.Validity.ValidFromTime });
		setEndDate({ ...endDate, date: parseDate(permitDetails.Validity.ValidTo, selectedLocale, 'L') });
		setEndTime({ ...endTime, text: permitDetails.Validity.ValidToTime });
		setSpaceNumber({ ...spaceNumber, text: permitDetails.FreetextParkingSpaceNo ?? '' })
		setNotes({ ...notes, text: permitDetails.Notes ?? '' });
		setInternalNotes({ ...internalNotes, text: permitDetails.InternalNote ?? '' });

    const isPastStartDate = moment().isAfter(moment(`${permitDetails.Validity.ValidFrom.split('T')[0]} ${permitDetails.Validity.ValidFromTime}`));
    setDisabledStartDate(isPastStartDate);

    const isPastEndDate = permitDetails.Validity.ValidTo ? moment().isAfter(moment(`${permitDetails.Validity.ValidTo.split('T')[0]} ${permitDetails.Validity.ValidToTime}`)) : false;
    setDisabledEndDate(isPastEndDate);

		if (placeSelectionOptions.length > 0) {
			const placeItem = placeSelectionOptions.filter(place => place.Id === permitDetails.PlaceUid);

			if (placeItem.length > 0) {
				setPlaceSelection({ ...placeSelection, item: placeItem[0] });

				const allTypes = placeItem[0].ProductMarketCombinations?.map(item => ({
					Id: item.Id,
					Name: item.Name,
					PmcId: item.PmcId,
					MaxSalesAmount: item.MaxSalesAmount,
					PermitDetailsSchedule: sortWeekdays(item.ServiceProfile?.Schedule),
					ReservationType: item.ReservationType,
					StartSellingDate: parseDate(item.StartSellingDate, selectedLocale, 'L')
				})) ?? [];
        const typeItem = allTypes.filter(type => type.PmcId === permitDetails.PmcIdRef);

        if (typeItem.length > 0)
					setTypeSelection({ ...typeSelection, item: typeItem[0] }), setOriginalTypeSelection(typeItem[0])
      }
		}

    setTimeout(() => {
			setPermitDetailsPending(false);
    }, 250);
  }, [permitDetails, placeSelectionOptions, placeSelectionPending])

	useEffect(() => {
		//Parse people into column list

		if (people.length === 0) {
      setQuantityCount(0);

			if (peopleList.length > 0)
				setPeopleList([]);

			return;
		}

    const quantityCount = people.map(item => parseInt(item.quantity ?? 1)).reduce((accumulator, currentValue) => accumulator + currentValue)
    setQuantityCount(quantityCount);

		const newPeopleList = people.map(person => {
			const personQty = (person.quantity && person.quantity > 1) ? [{ heading: `${lang.permit.quantity.replace('*', '')}: `, text: person.quantity }] : [];
			const personSpaceNumber = person.spaceNumber ? [{ heading: `${lang.permit.spacenumber}: `, text: person.spaceNumber }] : [];
			const personNotes = person.notes ? [{ heading: `${lang.permit.notes}: `, text: person.notes }] : [];
			const personInternalNotes = person.internalNotes ? [{ heading: `${lang.permit.internalnotes}: `, text: person.internalNotes }] : [];

			return {
				one: person.name ?? `${person.firstName} ${person.lastName}`,
				two: person.email ?? '-',
				three: person.registrationPlate,
				four: person.phone ?? '-',
				under: [...personQty, ...personSpaceNumber, ...personNotes, ...personInternalNotes],
				remove: lang.permit.buttons.remove,
				break: true,
			}
		});
		//*******************
		setPeopleList([
			{ one: lang.permit.name.replace('*', ''), two: lang.permit.email, three: lang.permit.licenseplate.replace('*', ''), four: lang.permit.phone, five: ' ', heading: true, break: true },
			...newPeopleList
		]);

  }, [people])

	useEffect(() => {
    if (permitId && !permitDetails)
      return

	  if (typeSelection.item.PmcId === emptyGuid || !startDate.date || !startTime.text || startTime.text.length < 5 || (disabledStartDate && disabledEndDate))
			return

    //Check if the permit details is different than selected values
	if (permitId && typeSelection.item.PmcId === originalTypeSelection?.PmcId &&
      startDate.date === moment(permitDetails.Validity.ValidFrom).locale(selectedLocale).format('L') &&
			((!endDate.date && !permitDetails.Validity.ValidTo) || 
			(endDate.date === moment(permitDetails.Validity.ValidTo).locale(selectedLocale).format('L'))) &&
      startTime.text === permitDetails.Validity.ValidFromTime &&
			endTime.text === permitDetails.Validity.ValidToTime) {
        setAvailableSpots(1)
        return
    }

    const checkAvailability = async () => {
      setAvailableSpotsPending(true)

      const availabilityData = { bookingController: '/booking/', pmcId: typeSelection.item.PmcId, startDate: `${startDate.date} ${startTime.text}`, endDate: `${endDate.date} ${endTime.text}` };
      const productAvailability = await products.getAvailability(availabilityData, false);

      setAvailableSpotsPending(false)

			if (productAvailability.status === 200) {
        const maxSalesAmount = typeSelection.item.MaxSalesAmount ?? 0;
        const availableSpotCount = productAvailability.body.Availability && productAvailability.body.Availability > 0 ? productAvailability.body.Availability : 0;

        if (maxSalesAmount < availableSpotCount)
          setAvailableSpots(maxSalesAmount);
        else
          setAvailableSpots(availableSpotCount);
      }
      else {
        setAvailableSpots(0);
      }
    }
    checkAvailability();
	}, [permitDetails, typeSelection.item.PmcId, startDate.date, startTime.text, endDate.date, endTime.text])

	useEffect(() => {
		setDateValidationError((startDate.error || endDate.error) ? true : false);

		if (!startDate.date || !startTime.text || !endDate.date) return;
		const parsedStartDate = parseDate(startDate.date);
		const parsedEndDate = parseDate(endDate.date);
		const compareTime = (end, start) => {
			return moment(parseDate(endDate.date + ' ' + end + ':00')).isBefore(start);
    }
		let nextFullHourToday = moment().add(10, "minutes").endOf('hour').add(1, "minutes");
		const startTimePlusMargin = moment(parseDate(startDate.date + ' ' + startTime.text + ':00')).add(10, "minutes");
		const endDateIsToday = parsedEndDate.isSame(new Date(), "day");
		const endDateIsSameDayAsStartDate = parsedEndDate.isSame(parsedStartDate, "day");
		if (endDateIsToday && endDateIsSameDayAsStartDate && startTimePlusMargin.isAfter(nextFullHourToday)) nextFullHourToday = startTimePlusMargin;
		const endTimeIsBeforeStartTime = endDateIsSameDayAsStartDate && startDate.date && startTime.text ? compareTime(endTime.text, startTimePlusMargin) : false;
		const endTimeIsBeforeNow = endDateIsToday && endTime.text ? endTime.text.split(':')[0] < moment(nextFullHourToday).format('HH') : false;
		if ((endDateIsToday && (!endTime.text || endTimeIsBeforeNow)) || endTimeIsBeforeStartTime) {
			const endTimeInput = document.querySelectorAll('input[type="time"]')[1];
			if (endTime.text && (endTimeIsBeforeNow || endTimeIsBeforeStartTime)) {
				endTimeInput.style.backgroundColor = "#fff4f5";
				endTimeInput.style.border = "1px solid #dd98a3";
				setTimeout(() => { endTimeInput.style.removeProperty('background-color'); endTimeInput.style.removeProperty('border'); }, 500);
			}
			setEndTime({
				...endTime, text: moment(endTimeIsBeforeStartTime ? startTimePlusMargin : nextFullHourToday).format("HH:mm")
			});
			endTimeInput.blur();
		}
	}, [startDate.date, endDate.date, endTime.text, startTime.text, startDate.error, endDate.error])


	useEffect(() => {
		//Focus trap

		const overlayFocusTrap = createFocusTrap(context);
		overlayFocusTrap.activate();

		return () => { overlayFocusTrap.deactivate(); }
  }, [])

	const checkEndTime = () => {
		if (!endDate.date && endTime.text) setEndTime({ ...defaultTextboxSettingsNotRequired, elementType: 'time' });
	}

	if (permitDetailsPending)
		return (
      <div className="myaimopark__overlay__loader">
        <div className="aimo-spinner"><span></span><span></span><span></span><span></span></div>
      </div>
    )

	if (permitDetailsError)
		return (
			<Error text={permitDetailsError} />
		)

	return (
		<div className="single-step">
			{permitId &&
				<EditCustomerForm
					countryCodeOptions={countryCodeOptions}
					notes={notes}
					setNotes={setNotes}
					internalNotes={internalNotes}
					setInternalNotes={setInternalNotes}
					spaceNumber={spaceNumber}
					setSpaceNumber={setSpaceNumber}
					lang={lang}
					formData={formData}
					pending={permitDetailsPending}
					disabledEndDate={disabledEndDate}
				/>
			}
			<TwoColumnWrapper>

				<DropdownlistWithLabel
					text={lang.permit.place}
					options={placeSelectionOptions}
					optionText="Name"
					value={placeSelection}
					setValue={setPlaceSelection}
					disabled={people.length > 0 || placeSelectionPending || placeSelection.length === 0 || disabledEndDate}
					loading={placeSelectionPending}
					dropdownId="placeSelectionOptions"
				/>

				<DropdownlistWithLabel
					extraClass="permit-details"
					text={lang.permit.type}
					options={typeSelectionOptions}
					optionIdentifier="PmcId"
					optionText="Name"
					value={typeSelection}
					setValue={setTypeSelection}
					disabled={people.length > 0 || typeSelectionOptions.length === 0 || disabledEndDate}
					dropdownId="typeSelectionOptions"
				>
					<button className="single-step__section--permit-details-button" disabled={typeSelection.item?.PmcId === emptyGuid || !typeSelection.item?.PermitDetailsSchedule || typeSelection.item?.PermitDetailsSchedule?.length === 0} onClick={() => { setShowPermitDetails(!showPermitDetails) }}>
						{lang.permit.details}
					</button>
				</DropdownlistWithLabel>

				{showPermitDetails &&
					<Lightbox onCloseEvent={() => { setShowPermitDetails(!showPermitDetails) }} close="Close" heading={typeSelection.item?.Name }>
						<div className="permit-details__lightbox">
							<p>{lang.permit.permitdetailstext}</p><br />
							{typeSelection.item?.PermitDetailsSchedule?.map(item => {
								return (
									<p key={item.DayOfWeek}>
										<span>{lang.permit.weekdays[item.DayOfWeek.toLowerCase()]}</span>
										<span>{`${item.StartTime.substring(0, 5)}–${item.EndTime.substring(0, 5)}`}</span>
									</p>
								)
							})}
						</div>
					</Lightbox>
				}

				<TwoColumnWrapper>
					<DateSelectionWithLabel
						extraClass="startdate"
						text={lang.permit.startdate}
						extraText={' ' + lang.permit.andtime + '*'}
						value={startDate}
						setValue={setStartDate}
						disabled={disabledStartDate}
						locale={selectedLocale}
						language={selectedLang}
						placeholder={lang.permit.selectdate}
						showAllDates={true}
						selectedDays={[
							startDate.date && new Date(parseDate(startDate.date)),
							{
								from: startDate.date && new Date(parseDate(startDate.date)),
								to: endDate.date && new Date(parseDate(endDate.date))
							}
						]}
						disabledDays={ endDate.date && {
							before: new Date(),
							after: new Date(parseDate(endDate.date))
						}}
						month={startDate.date ? new Date(parseDate(startDate.date)) : new Date()} fromMonth={new Date()}
						startSellingDate={ typeSelection.item.StartSellingDate }
					/>
					<InputWithLabel
						inputType="time"
						text={lang.permit.starttime}
						defaultText={startTime}
						value={startTime}
						setValue={setStartTime}
						placeholder="09:00"
						disabled={disabledStartDate}
						debounce={300}
					/>
				</TwoColumnWrapper>
				<TwoColumnWrapper>

					<DateSelectionWithLabel
						onBlur={checkEndTime}
						extraClass="enddate"
						text={lang.permit.enddate}
						extraText={' ' + lang.permit.andtime}
						value={endDate}
						setValue={setEndDate}
						disabled={disabledEndDate}
						locale={selectedLocale}
						language={selectedLang}
						placeholder={lang.permit.selectdate}
						showAllDates={true}
						selectedDays={[
							disabledStartDate ? new Date() : startDate.date && new Date(parseDate(startDate.date)),
							{
								from: disabledStartDate ? new Date() : startDate.date && new Date(parseDate(startDate.date)),
								to: endDate.date && new Date(parseDate(endDate.date))
							}
						]}
						disabledDays={{
							before: disabledStartDate ? new Date() : startDate.date ? new Date(parseDate(startDate.date)) : new Date()
						}}
						month={disabledStartDate ? new Date() : startDate.date && new Date(parseDate(startDate.date))}
						fromMonth={disabledStartDate ? new Date() : startDate.date && new Date(parseDate(startDate.date))}
					/>

					<InputWithLabel
						inputType="time"
						text={lang.permit.endtime}
						defaultText={endTime}
						value={endTime}
						setValue={setEndTime}
						placeholder="21:00"
						disabled={disabledEndDate}
						debounce={300}
					/>

				</TwoColumnWrapper>
			</TwoColumnWrapper>

			{permitId &&
				<TwoColumnWrapper>
					<TwoColumnWrapper>

						<InputWithLabel
							inputType="text"
							text={lang.permit.spacenumber + (typeSelection.item.ReservationType == 'LANDLORD_RESERVED' ? '*' : '')}
							value={typeSelection.item.ReservationType == 'LANDLORD_RESERVED' ? spaceNumber : ''}
							setValue={typeSelection.item.ReservationType == 'LANDLORD_RESERVED' ? setSpaceNumber : ''}
							disabled={disabledEndDate || typeSelection.item.ReservationType !== 'LANDLORD_RESERVED'}
							maxLength={255}
						/>

						<div></div>

					</TwoColumnWrapper>
				</TwoColumnWrapper>
			}

			{customerNumber && (
				<TwoColumnWrapper>

					<InputWithLabel
						inputType="quantity"
						text={lang.permit.quantity}
						defaultText={quantity}
						value={quantity}
						setValue={setQuantity}
						disabled={disabledEndDate}
					/>

					<InputWithLabel
						inputType="text"
						text={lang.permit.spacenumber + (typeSelection.item.ReservationType == 'LANDLORD_RESERVED' ? '*' : '')}
						value={spaceNumber}
						setValue={setSpaceNumber}
						disabled={disabledEndDate || typeSelection.item.ReservationType !== 'LANDLORD_RESERVED'}
						maxLength={255}
					/>

				</TwoColumnWrapper>
			)}

			{(permitId || customerNumber) &&
				<TextareaWithLabel
					text={lang.permit.notes}
					description={lang.permit.permitnotes}
					value={notes}
					setValue={setNotes}
					placeholder="Add your notes here"
					disabled={disabledEndDate}
					maxLength={255}
				/>
			}

			{(permitId || customerNumber) &&
				<TextareaWithLabel
					text={lang.permit.notes}
					description={lang.permit.internalnotes}
					value={internalNotes}
					setValue={setInternalNotes}
					placeholder="Add your notes here"
					maxLength={255}
				/>
			}

			{(!customerNumber && availableSpots !== null && availableSpots === 0) && (
        <div className="myaimopark__overlay__error">
          <div className="myaimopark__overlay__error__inner">
            <p className="nomargin">
							{lang.errorMessages.noavailability}
            </p>
          </div>
        </div>
      )}

			{(!permitId && !customerNumber && availableSpots !== null && availableSpots > 0 && quantityCount > availableSpots) && (
        <div className="myaimopark__overlay__error">
          <div className="myaimopark__overlay__error__inner">
            <p className="nomargin">
							{lang.errorMessages.toomany}
            </p>
          </div>
        </div>
      )}

			{(!permitId && !customerNumber && placeSelection && availableSpots !== null && availableSpots > 0) && (
				<Fragment>
					<Divider />
					<h3 className="nomargin">
						{lang.permit.headings.addpeople}
					</h3>

					{availableSpots && quantityCount === 0 &&
						<p className="center small margin">
							Permit quantity limit: {availableSpots}
						</p>
					}

					{availableSpots && quantityCount > 0 &&
						<p className="center small margin">
							Permits used: {quantityCount} of {availableSpots}
						</p>
					}

					{peopleList && peopleList.length > 1 && !permitCreateError &&
						<ColumnList
							disabled={disabledEndDate}
							rows={peopleList}
							class="single-step__column-list--five"
							removeCallback={removeUserCallbackClickHandler}
						/>
					}

					{(showRegisteredCustomerForm || showUnregistredCustomerForm) && 
						<>
							<CustomerForm
								countryCodeOptions={countryCodeOptions}
								defaultCountryCode={defaultCountryCode}
								typeSelection={typeSelection}
								setTypeSelection={setTypeSelection}
								savedSpaceNumber={people.length ? people[people.length - 1].spaceNumber : ''}
								savedNotes={people.length ? people[people.length - 1].notes : ''}
								lang={lang}
								selectedLang={selectedLang}
								currentCountry={currentCountry}
								defaultTextboxSettings={defaultTextboxSettings}
								addUserCallback={addUserCallbackClickHandler}
								showRegisteredCustomerForm={showRegisteredCustomerForm}
								availablePermitCount={availableSpots - quantityCount}
								disabledSpaceNumber={typeSelection.item.ReservationType !== 'LANDLORD_RESERVED'}
							/>
						</>
					}
					<TwoColumnWrapper>
						<div className="landlord-permit-form__add-links">
							<button onClick={showRegisteredCustomerFormClickHandler} disabled={disabledEndDate || (availableSpots && availableSpots <= quantityCount)}>
								{lang.permit.buttons.addregisteredcustomer}
							</button>
							<button onClick={showUnregistredCustomerFormClickHandler} disabled={disabledEndDate || (availableSpots && availableSpots <= quantityCount)}>
								{lang.permit.buttons.addunregisteredcustomer}
							</button>
						</div>
						<div className="landlord-permit-form__add-import">
							<button onClick={() => showImportCustomerOverlayClickHandler(null)} disabled={disabledEndDate || (availableSpots && availableSpots <= quantityCount)}>
								{lang.permit.buttons.importbyfile}
							</button>
						</div>
						<div className="landlord-permit-form__add-import">
							<button onClick={() => window.open(lang.permit.permitsTemplateUrl)}>
								{lang.permit.downloadtemplate}
							</button>
						</div>
					</TwoColumnWrapper>
				</Fragment>
			)}

			<Divider />

			{(permitCreateError) && (
				<Fragment>
					<h3 className="nomargin">
						Created permits
					</h3>
					<p className="center small margin red">
						One or more permits failed to be created. Please contact Aimo Park for help.
					</p>
					{peopleList && peopleList.length > 1 &&
						<ColumnList
							rows={peopleList}
							class="single-step__column-list--five"
							removeCallback={removeUserCallbackClickHandler}
						/>
					}
				</Fragment>
			)}

			{(permitUpdateError) && (
				<Error text={permitUpdateErrorMessage} />
			)}

			<OneLineWrapper>
				<button className="single-step__button single-step__button--cancel" disabled={postFormPending || showSaveButtonCheck} onClick={cancelClickHandler}>
					{lang.cancel}
				</button>
				<button className={`single-step__button single-step__button--saveable ${showSaveButtonCheck ? (!permitId && disabledEndDate ? "single-step__button--complete-create" : "single-step__button--complete") : ""}`} data-pp-button={permitId ? "save-permit" : "create-permit"} disabled={dateValidationError || showSaveButtonCheck || disabledEndDate || ((permitId || customerNumber) ? (postFormPending || availableSpots === 0 || (availableSpots !== null && quantityCount > availableSpots)) : (postFormPending || people.length === 0 || (availableSpots !== null && quantityCount > availableSpots)))} aria-busy={postFormPending} onClick={saveClickHandler}>
					{lang.save}
				</button>
			</OneLineWrapper>

			{savedPermits &&
				<Dialog lang={{ confirm: lang.permit.buttons.okclose, heading: lang.permit.headings.saved }} onDialogConfirm={handleDialogConfirm}>
					<p>{savedPermits > 1 ? lang.permit.savedpermits.replace('{0}', savedPermits) : lang.permit.savedpermit }.</p>
				</Dialog>
			}

			{showImportCustomerOverlay &&
				<ImportCustomerOverlay
					lang={lang}
					people={people}
					setPeople={setPeople}
					showImportCustomerOverlayClickHandler={showImportCustomerOverlayClickHandler}
					importOverlayBackgroundRef={importOverlayBackgroundRef}
					availablePermitCount={availableSpots - quantityCount}
					isReserved={typeSelection.item.ReservationType == 'LANDLORD_RESERVED'}
				/>
			}
		</div>
	);
}

const CustomerForm = ({ countryCodeOptions, defaultCountryCode, savedNotes, savedSpaceNumber, lang, selectedLang, currentCountry, defaultTextboxSettings, addUserCallback, showRegisteredCustomerForm, availablePermitCount, disabledSpaceNumber, typeSelection, setTypeSelection }) => {
	const [userSelection, setUserSelection] = useState({ item: { Name: lang.permit.selectperson, Uid: emptyGuid }, required: showRegisteredCustomerForm, elementType: 'select' });
  const [userSelectionOptions, setUserSelectionOptions] = useState([]);
	const [userSelectionPending, setUserSelectionPending] = useState(false);
	const [firstName, setFirstName] = useState({ ...defaultTextboxSettings, required: !showRegisteredCustomerForm });
	const [lastName, setLastName] = useState({ ...defaultTextboxSettings, required: !showRegisteredCustomerForm });

	const [email, setEmail] = useState({ ...defaultTextboxSettings, elementType: 'email', required: false });
	const [phone, setPhone] = useState({ ...defaultTextboxSettings, required: false, elementType: 'phone' });
	const [registrationPlate, setRegistrationPlate] = useState({ ...defaultTextboxSettings, required: !showRegisteredCustomerForm });
	const [notes, setNotes] = useState({ text: savedNotes ?? '', required: false });
	const [internalNotes, setInternalNotes] = useState({...defaultTextboxSettings, required: false });
	const [spaceNumber, setSpaceNumber] = useState({ text: savedSpaceNumber ?? '', required: !disabledSpaceNumber });
  const [quantity, setQuantity] = useState({ text: '1', required: showRegisteredCustomerForm, elementType: 'number' });
	const [countryCode, setCountryCode] = useState({ item: { Name: defaultCountryCode, Id: defaultCountryCode }, required: false,elementType: "select" });

	useEffect(() => {
		setSpaceNumber({ text: disabledSpaceNumber ? '' : (savedSpaceNumber ?? ''), required: !disabledSpaceNumber });
	}, [disabledSpaceNumber])

	let phoneNumberPlaceholder = '+46123456789'
	if (currentCountry === 'no')
		phoneNumberPlaceholder = '+47123456789'
	else if (currentCountry === 'fi')
		phoneNumberPlaceholder = '+35812345678'

	const addUserClickHandler = () => {
		const required = showRegisteredCustomerForm ? false : true
		let newUserForm = {
			userSelection: {
				value: { ...userSelection, required: !required }, setValue: setUserSelection, optionIdentifier: 'Uid' },
			firstName: {
				value: { ...firstName, required }, setValue: setFirstName },
			lastName: {
				value: { ...lastName, required }, setValue: setLastName },
			email: {
				value: { ...email, required: !required }, setValue: setEmail },
			phone: {
				value: phone, setValue: setPhone },
			notes: {
				value: notes, setValue: setNotes
			},
			internalNotes: {
				value: internalNotes, setValue: setInternalNotes
			},
			spaceNumber: {
				value: spaceNumber, setValue: setSpaceNumber },
		};

		if (showRegisteredCustomerForm)
			newUserForm.quantity = {
				value: { ...quantity, required: !required
			}, 
				setValue: setQuantity };
    else {
			newUserForm.registrationPlate = {
				value: { ...registrationPlate, required, elementType: 'licenseplate', countryCode: countryCode.item.Id }, setValue: setRegistrationPlate
			};
			newUserForm.countryCode = {
				value: { ...countryCode, required }, setValue: setCountryCode
			};
		}
		newUserForm.typeSelection = { value: { ...typeSelection, required: true }, setValue: setTypeSelection, optionIdentifier: 'PmcId' }

		let [formValidationError, cleanFormData, flatCleanFormData] = validateFormObject(newUserForm, lang.errorMessages);

		if (formValidationError) {
			setTimeout(() => {
				const firstInvalidElement = document.querySelector('[aria-invalid]').closest('div').previousElementSibling || document.querySelector('[aria-invalid]');
				if (firstInvalidElement) firstInvalidElement.scrollIntoView({ behavior: 'smooth' });
			}, 200);
			return;
		}

    if (showRegisteredCustomerForm && availablePermitCount < quantity.text) {
      setQuantity({ ...quantity, error: `Max permits: ${availablePermitCount}` });
      return;
    }

		let newuser = showRegisteredCustomerForm ? {
			id: cleanFormData.userSelection.item.Uid,
			name: cleanFormData.userSelection.item.Name ?? '',
			email: cleanFormData.email.text.length > 0 ? cleanFormData.email.text : '-',
			phone: cleanFormData.phone.text.length > 0 ? cleanFormData.phone.text : '-',
			notes: cleanFormData.notes.text.length > 0 ? cleanFormData.notes.text : '',
			internalNotes: cleanFormData.internalNotes.text.length > 0 ? cleanFormData.internalNotes.text : '',
			spaceNumber: cleanFormData.spaceNumber.text.length > 0 ? cleanFormData.spaceNumber.text : '',
		} : {
			id: 'new',
			...flatCleanFormData,
			email: cleanFormData.email.text.length > 0 ? cleanFormData.email.text : '-',
			phone: flatCleanFormData.phone.length > 0 ? flatCleanFormData.phone : '-',
			notes: cleanFormData.notes.text.length > 0 ? cleanFormData.notes.text : '',
			internalNotes: cleanFormData.internalNotes.text.length > 0 ? cleanFormData.internalNotes.text : '',
			spaceNumber: cleanFormData.spaceNumber.text.length > 0 ? cleanFormData.spaceNumber.text : '',
		};
		if (showRegisteredCustomerForm)
      newuser.quantity = cleanFormData.quantity.text,
      newuser.registrationPlate = '-';
    else
			newuser.registrationPlate = cleanFormData.registrationPlate.text.length > 0 ? cleanFormData.registrationPlate.text : '-',
			newuser.countryCode = cleanFormData.countryCode.item.Id;

		addUserCallback(newuser);
	}

	useEffect(() => {
    let isSubscribed = true;

    const getUsers = async () => {
      setUserSelectionPending(true);

			const allUsers = await permitService.getCustomers(false);

      if (allUsers.status === 200 && isSubscribed) {
        setUserSelectionPending(false);
        setUserSelectionOptions(allUsers.body);
      }
    }
    getUsers();

    return () => isSubscribed = false;
  }, [])

	useEffect(() => {
    if (userSelection.item.Uid === emptyGuid)
      return;

		if (userSelection.item.ContactEmail) setEmail({ ...email, text: userSelection.item.ContactEmail });
		else setEmail({ ...email, text: '' });

		const phone = userSelection.item.MobilePhone ?? userSelection.item.Phone;
		if (phone) setPhone({ ...phone, text: phone });
    else setPhone({ ...phone, text: '' });
  }, [userSelection])

	return (
		<div className="add-user-form">
			<TwoColumnWrapper>

				{showRegisteredCustomerForm &&
					<DropdownlistWithLabel
						searchable={true}
						searchPlaceholder={lang.permit.searchcustomer}
						customerNotFound={lang.permit.nocustomers}
						scrollElement=".myaimopark__overlay main"
						text={lang.permit.name}
						options={userSelectionOptions}
						optionIdentifier="Uid"
						optionText="Name"
						optionTextFallback="ContactEmail"
						value={userSelection}
						setValue={setUserSelection}
						disabled={userSelectionPending || userSelection.length === 0}
						loading={userSelectionPending}
						dropdownId="userSelectionOptions"
					/>
				}

				{/*{showRegisteredCustomerForm && <div className="single-step__section"></div>}*/}

				{!showRegisteredCustomerForm &&
					<InputWithLabel
						text={lang.permit.firstname}
						value={firstName}
						setValue={setFirstName}
					/>
				}

				{!showRegisteredCustomerForm &&
					<InputWithLabel
						text={lang.permit.lastname}
						value={lastName}
						setValue={setLastName}
					/>
				}

				{/*{!showRegisteredCustomerForm && <div className="single-step__section"></div>}*/}

				<InputWithLabel
					text={lang.permit.email + (email.required ? "*" : "")}
					defaultText={email}
					value={email}
					setValue={setEmail}
					disabled={showRegisteredCustomerForm}
				/>

				{!showRegisteredCustomerForm &&
					<InputWithLabel
						text={lang.permit.phone}
						value={phone}
						setValue={setPhone}
						placeholder={!showRegisteredCustomerForm ? phoneNumberPlaceholder : undefined}
						disabled={showRegisteredCustomerForm}
					/>
				}

			</TwoColumnWrapper>

			<TextareaWithLabel
				text={lang.permit.notes}
				description={lang.permit.permitnotes}
				value={notes}
				setValue={setNotes}
				placeholder="Add your notes here"
				maxLength={255}
			/>

			<TextareaWithLabel
				text={lang.permit.notes}
				description={lang.permit.internalnotes}
				value={internalNotes}
				setValue={setInternalNotes}
				placeholder="Add your notes here"
				maxLength={255}
			/>

			<TwoColumnWrapper>

				{!showRegisteredCustomerForm && (
					<TwoColumnWrapper modifier="equal">

						<InputWithLabel
							toUpperCase={true}
							maxLength={10}
							text={lang.permit.licenseplate}
							value={registrationPlate}
							setValue={setRegistrationPlate}
						/>

						<DropdownlistWithLabel
							text={lang.permit.countrycode}
							options={countryCodeOptions}
							optionText="Name"
							value={countryCode}
							setValue={setCountryCode}
							dropdownId="countryCodeOptions"
						/>

					</TwoColumnWrapper>
				)}

				{showRegisteredCustomerForm && (
					<TwoColumnWrapper modifier="equal">

						<InputWithLabel
							text={lang.permit.spacenumber + (spaceNumber.required ? '*' : '')}
							value={spaceNumber}
							setValue={setSpaceNumber}
							maxLength={255}
							disabled={disabledSpaceNumber}
						/>

						<InputWithLabel
							maxLength={10}
							text={lang.permit.quantity}
							value={quantity}
							setValue={setQuantity}
							inputType='quantity'
						/>

					</TwoColumnWrapper>
				)}

				<TwoColumnWrapper modifier="add-form">

					{!showRegisteredCustomerForm ?
						<InputWithLabel
							text={lang.permit.spacenumber + (spaceNumber.required ? '*' : '')}
							value={spaceNumber}
							setValue={setSpaceNumber}
							maxLength={255}
							disabled={disabledSpaceNumber}
						/> : <div></div>
					}

          <div className="single-step__section single-step__section--add-form">
            <span className="single-step__section__label">&nbsp;</span>
						<button className="single-step__button" onClick={addUserClickHandler} disabled={(showRegisteredCustomerForm && userSelection.item.Id === emptyGuid)}>
							{lang.permit.buttons.add}
						</button>
					</div>

				</TwoColumnWrapper>
			</TwoColumnWrapper>
		</div>
	);
}

const EditCustomerForm = ({ spaceNumber, setSpaceNumber, countryCodeOptions, lang, formData, pending, disabledEndDate }) => {
	const [userSelectionOptions, setUserSelectionOptions] = useState([]);
	const [userSelectionPending, setUserSelectionPending] = useState(false);

	useEffect(() => {
    let isSubscribed = true;

    const getUsers = async () => {
      setUserSelectionPending(true);

			const allUsers = await permitService.getCustomers(false);

      if (allUsers.status === 200 && isSubscribed) {
        setUserSelectionPending(false);
				setUserSelectionOptions(allUsers.body);
      }
		}
    getUsers();
    return () => isSubscribed = false;
  }, [])

	useEffect(() => {
		if (formData.currentUserSelection === emptyGuid || userSelectionOptions.length === 0)
			return;

		const currentUserItem = userSelectionOptions.filter(user => user.Uid === formData.currentUserSelection);
		
		if (currentUserItem.length > 0 && currentUserItem[0].Uid !== emptyGuid) {
			formData.setUserSelection({ ...formData.userSelection, item: currentUserItem[0] });
    }

	}, [userSelectionOptions])

	useEffect(() => {
		if (formData.userSelection.item?.uid != emptyGuid && formData.userSelection.error) {
			formData.setUserSelection({...formData.userSelection, error: null})
		}
	}, [formData.userSelection])

	return (
		<Fragment>

			<TwoColumnWrapper>

				<DropdownlistWithLabel
					text={'Customer type'}
					options={formData.userTypeOptions}
					value={formData.userType}
					setValue={formData.setUserType}
					disabled={pending || disabledEndDate}
					dropdownId="userTypeOptions"
				/>

				{formData.userType.item.Id === 'registered' &&

					<DropdownlistWithLabel searchable={true}
						searchPlaceholder={lang.permit.searchcustomer}
						customerNotFound={lang.permit.nocustomers}
						scrollElement=".myaimopark__overlay main"
						text={lang.permit.name}
						options={userSelectionOptions}
						optionIdentifier="Uid"
						optionText="Name"
						optionTextFallback="ContactEmail"
						value={formData.userSelection}
						setValue={formData.setUserSelection}
						disabled={userSelectionPending || userSelectionOptions.length === 0 || pending || disabledEndDate}
						dropdownId="userSelectionOptions"
					/>

				}

				{formData.userType.item.Id === 'unregistered' &&

					<div className="single-step__section"></div>

				}

				{formData.userType.item.Id === 'registered' &&

					<Fragment>

						{/*Do we need first- and last name?*/}
						{/*{(formData.userSelection.item.customerType === 'B2B' || (formData.userSelection.item?.firstName && !formData.userSelection.item?.lastName)) &&*/}
					
						<InputWithLabel
							inputType="text"
							text={lang.permit.name.replace('*', '')}
							value={{
								text: (!userSelectionPending && formData.userSelection.item?.Name && formData.userSelection.item?.Uid != emptyGuid) ? formData.userSelection.item?.Name : '-'
							}}
							displayAsText={true}
						/>
					
						{/*}*/}

						{/*{(formData.userSelection.item.customerType === 'B2C' || (formData.userSelection.item?.firstName && formData.userSelection.item?.lastName)) && <Fragment>*/}
						{/*	<InputWithLabel inputType="text" text={lang.permit.firstname} value={{ text: formData.userSelection.item?.firstName ?? '-' }} displayAsText={true} />*/}
						{/*	<InputWithLabel inputType="text" text={lang.permit.lastname} value={{ text: formData.userSelection.item?.lastName ?? '-' }} displayAsText={true} />*/}
						{/*	</Fragment>*/}
						{/*}*/}

						<InputWithLabel
							inputType="text"
							text={lang.permit.email}
							value={{
								text: formData.userSelection.item?.ContactEmail ?? '-'
							}}
							displayAsText={true}
						/>

						<InputWithLabel
							inputType="text"
							text={lang.permit.phone}
							value={{
								text: (formData.userSelection.item?.Phone || formData.userSelection.item?.MobilePhone) || '-'
							}}
							displayAsText={true}
						/>

						{/*{formData.userSelection.item?.uid !== formData.currentUserSelection && */}

						<TwoColumnWrapper>

							<InputWithLabel
								text={lang.permit.quantity.replace('*', '')}
								defaultText={formData.quantity}
								value={formData.quantity}
								setValue={formData.setQuantity}
								disabled={pending}
								inputType='number'
								displayAsText={true}
							/>

							<div></div>

						</TwoColumnWrapper>

						{/*}*/}

					</Fragment>

				}

				{formData.userType.item.Id === 'unregistered' &&

					<Fragment>

						<InputWithLabel
							inputType="text"
							text={lang.permit.firstname}
							value={formData.firstName}
							setValue={formData.setFirstName}
							disabled={pending || disabledEndDate}
						/>

						<InputWithLabel
							inputType="text"
							text={lang.permit.lastname}
							value={formData.lastName}
							setValue={formData.setLastName}
							disabled={pending || disabledEndDate}
						/>

						<InputWithLabel
							inputType="text"
							text={lang.permit.email}
							value={formData.email}
							setValue={formData.setEmail}
							disabled={pending || disabledEndDate}
						/>

						<InputWithLabel
							inputType="text"
							text={lang.permit.phone}
							value={formData.phone}
							setValue={formData.setPhone}
							disabled={pending || disabledEndDate}
						/>

						<TwoColumnWrapper modifier="equal">

							<InputWithLabel
								toUpperCase={true}
								maxLength={10}
								inputType="text"
								text={lang.permit.licenseplate}
								value={formData.registrationPlate}
								setValue={formData.setRegistrationPlate}
								disabled={pending || disabledEndDate}
							/>

							{/*	<InputWithLabel inputType="text" text={lang.permit.spacenumber} value={spaceNumber} setValue={setSpaceNumber} disabled={disabledEndDate} />*/}

							<DropdownlistWithLabel
								text={lang.permit.countrycode}
								options={countryCodeOptions}
								optionText="Name"
								value={formData.countryCode}
								setValue={formData.setCountryCode}
								disabled={pending || disabledEndDate}
								dropdownId="countryCodeOptions"
							/>

						</TwoColumnWrapper>

					</Fragment>
				}

			</TwoColumnWrapper>

			<Divider />

		</Fragment>

	);
}

const ImportCustomerOverlay = ({ lang, people, setPeople, showImportCustomerOverlayClickHandler, importOverlayBackgroundRef, availablePermitCount, isReserved }) => {
	const fileUpload = useRef(null)
  const fileUploadLabel = useRef(null)

	const [requestAnimation, setRequestAnimation] = useState(false);
	const [maxHeight, setMaxHeight] = useState({ maxHeight: '100%' });

	const [fileSelected, setFileSelected] = useState(0);
	const [fileValid, setFileValid] = useState(false);
	const [peopleToImport, setPeopleToImport] = useState([]);
	const [peopleToImportInvalid, setPeopleToImportInvalid] = useState([]);

	const [pendingValidation, setPendingValidation] = useState(false);
	const [validationError, setValidationError] = useState(false);
  const [toManyPermitsError, setToManyPermitsError] = useState(false);

	const showFileUploadName = (e) => {
    if(e.target.value) {
			fileUploadLabel.current.innerHTML = e.target.value.split('\\').pop();
			setFileSelected(fileSelected + 1);
			setPendingValidation(true);

      setValidationError(false);
      setToManyPermitsError(false);
    } else {
			fileUploadLabel.current.innerHTML = '&nbsp;';
			setFileSelected(0);
    }
  };

	const continueClickHandler = () => {
		setPeople([...people, ...peopleToImport]);
		showImportCustomerOverlayClickHandler(null);
	}

	useEffect(() => {
		if (fileSelected === 0)
			return;

		setPeopleToImportInvalid([]);

		readXlsxFile(fileUpload.current.files[0]).then((rows) => {

			const createError = () => {
				setFileValid(false);
				setPendingValidation(false);
				setValidationError(true);
				setPeopleToImport([]);
      }

			if (rows.length === 0 || rows[0].length === 0 || rows[0].length > 7 || !rows[0].some(h => h && typeof h === 'string' && h.toLowerCase().includes('first'))) {
				createError();
				return;
			}

			const invalidRows = {validationErrors: [], missingMandatory: []};
			const headings = rows.shift().map(heading => { return heading &&  heading.toLowerCase() })
			const order = new Array(7)

			if (headings.some(h => h && h.includes('first')) && headings.some(h => h && h.includes('last')) && headings.some(h => h && h.includes('license'))) {
				headings.forEach((heading, i) => {
					if (heading.includes('first')) order[0] = i
					if (heading.includes('last')) order[1] = i
					if (heading.includes('license')) order[2] = i
					if (heading.includes('e-mail')) order[3] = i
					if (heading.includes('phone')) order[4] = i
					if (heading.includes('notes')) order[5] = i
					if (heading.includes('space')) order[6] = i
				})
			} else {
				createError();
				return;
      }
			const validRows = rows.map((row, index) => {
				if (row.length < 8 && row.length > 2 && row[order[0]].length > 0 && row[order[1]].length > 0 && row[order[2]]?.length > 0 && ((!row[order[3]] || emailValidation(row[order[3]])) && (!row[order[4]] || phoneNumberValidation(row[order[4]]))) && ((isReserved && row[order[6]]) || !isReserved)) {
					return {
						id: 'new',
						firstName: row[order[0]],
						lastName: row[order[1]],
						registrationPlate: row[order[2]],
						email: row[order[3]],
						phone: row[order[4]],
						notes: row[order[5]] ? (row[order[5]].length < 256 ? row[order[5]] : row[order[5]].substring(0, 255)) : null,
						spaceNumber: row[order[6]] ? (row[order[6]].length < 256 ? row[order[6]] : row[order[6]].toString().substring(0, 255)) : null
					};
				} else {
					if ((row[order[3]] && !emailValidation(row[order[3]])) || (row[order[4]] && !phoneNumberValidation(row[order[4]]))) invalidRows.validationErrors.push(index + 1);
					if (!row[order[0]] || !row[order[1]] || !row[order[2]] || (isReserved && !row[order[6]])) invalidRows.missingMandatory.push(index + 1);
				}
			})

			if (invalidRows.validationErrors.length > 0 || invalidRows.missingMandatory.length > 0) {
				setPeopleToImportInvalid(invalidRows);
				createError();
				return;
			}

      if (availablePermitCount < rows.length) {
				createError();
        return;
      }

			setPeopleToImport(validRows);
			setFileValid(true);
			setPendingValidation(false);
			setValidationError(false);
		})
  }, [fileSelected])

	useEffect(() => {
		const initMaxHeight = (e) => {
			if (!requestAnimation) {
				window.requestAnimationFrame(() => {
					setMaxHeight({ maxHeight: `${window.innerHeight}px` });

					setRequestAnimation(false);
				});
			}

			setRequestAnimation(false);
		};

    window.addEventListener('resize', initMaxHeight);
		initMaxHeight();

    return () => window.removeEventListener('resize', initMaxHeight);
  }, [])

	useEffect(() => {
		if (!importOverlayBackgroundRef.current)
			return;

		const overlayFocusTrap = createFocusTrap(importOverlayBackgroundRef.current);
		overlayFocusTrap.activate();

		return () => { overlayFocusTrap.deactivate(); }
  }, [importOverlayBackgroundRef])

	return (
		<div className="importcustomeroverlay" ref={importOverlayBackgroundRef} onClick={(e) => showImportCustomerOverlayClickHandler(e)}>
      <div className="importcustomeroverlay__inner" style={maxHeight}>
        <header>
          {lang.permit.headings.importbyfile}
          <button onClick={() => showImportCustomerOverlayClickHandler(null)} className="importcustomeroverlay__close">{lang.overlay.close}</button>
        </header>
        <main>
					<p>{lang.permit.selectfileforimport}</p>
					<input type="file" name="file" id="file" ref={fileUpload} className="importcustomeroverlay__file" onClick={(e) => e.target.value = ''} accept=".xlsx" onChange={showFileUploadName} disabled={pendingValidation} />
					<button className="importcustomeroverlay__file__label" onClick={() => fileUpload.current.click()} disabled={pendingValidation}>
            <div className="importcustomeroverlay__file__text" ref={fileUploadLabel}>&nbsp;</div>
						<div className="single-step__button" disabled={pendingValidation} aria-busy={pendingValidation}>{lang.permit.selectfile}</div>
					</button>
					{lang.permit.permitsTemplateUrl && <a href={lang.permit.permitsTemplateUrl} className="download">{lang.permit.downloadtemplate}</a>}
					{fileSelected > 0 && validationError && (<div className="importcustomeroverlay__information importcustomeroverlay__information--error">
						<p className="heading">{lang.permit.error.heading}</p>
						<p>{lang.permit.error.text.replace('{*}', isReserved ? '*' : '')}</p>
						{peopleToImportInvalid.validationErrors.length > 0 && <p>{lang.permit.error.textrows} <strong>{peopleToImportInvalid.validationErrors.join(', ')}</strong></p>}
						{peopleToImportInvalid.missingMandatory.length > 0 && <p>{lang.permit.error.textrowsmandatory} <strong>{peopleToImportInvalid.missingMandatory.join(', ')}</strong></p>}
					</div>)}
          {fileSelected > 0 && toManyPermitsError && (<div className="importcustomeroverlay__information importcustomeroverlay__information--error">
						<p className="heading">{lang.permit.error.permitlimitheading}</p>
						<p>{lang.permit.error.permitlimittext.replace('{permitcount}', availablePermitCount)}</p>
					</div>)}
					{fileSelected > 0 && fileValid && (<div className="importcustomeroverlay__information">
						<p className="heading">{lang.permit.information.heading}</p>
						<p>{peopleToImport.length === 1 ? lang.permit.information.textsingle : lang.permit.information.textmultiple.replace('{0}', peopleToImport.length)}</p>
					</div>)}
        </main>
        <footer>
					<OneLineWrapper>
						<button onClick={() => showImportCustomerOverlayClickHandler(null)} className="single-step__button single-step__button--cancel">{'Cancel'}</button>
						<button onClick={continueClickHandler} className="single-step__button" disabled={peopleToImport.length === 0}>{lang.permit.buttons.continue}</button>
					</OneLineWrapper>
        </footer>
      </div>
    </div>

	);
}

export default PermitForm;
